// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"d544b2ec","627":"41561b6c","663":"aad0c761","667":"f1fe7373","777":"395ac711","803":"bde85d99","820":"90e1a2ab"}[chunkId] + ".chunk.js";
};